import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from '../reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'globalSearch',
    'userGroups',
    'recentProductSearch',
    'dismissFeatures',
    'generalManagerStores',
    'dateFilter',
    'emailPreferences',
    'calendarRange',
    'nonFilterPlpSelection',
    'divisionsMasterList',
    'clientsGroupSelectedSort',
    'looksModule',
  ],
};

const createStoreWithLogging = () => applyMiddleware(createLogger());
const createStoreWithMiddleware = () => applyMiddleware(thunk);
let finalCreateStore;

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
  finalCreateStore = composeWithDevTools(createStoreWithMiddleware(), createStoreWithLogging())(createStore);
} else {
  finalCreateStore = compose(createStoreWithMiddleware())(createStore);
}

const configureStore = (initialState) => {
  const persistedReducer = persistReducer(persistConfig, rootReducer);
  const store = finalCreateStore(persistedReducer, initialState);
  const persistor = persistStore(store);
  if (typeof module !== 'undefined') {
    module.hot?.accept('../reducers', () =>
      /* eslint-disable-next-line global-require */
      store.replaceReducer(persistReducer(persistConfig, require('../reducers').default)),
    );
  }

  return { store, persistor };
};

const configureStoreForTests = (initialState) => {
  // Without persist
  return createStoreWithMiddleware()(createStore)(rootReducer, initialState);
};

const initialState = {};

const { store, persistor } = configureStore(initialState);

export { store, persistor, configureStoreForTests };
